





import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import InviteMember from '@/components/common/InviteMember.vue';

@Component({
  components: {
    InviteMember,
  },
})
export default class AddMemberModal extends Vue {
  @Prop({ required: true })
  private isOpenAddMemberModal!: boolean;

  @Emit('closeAddMemberModal')
  private closeAddMemberModal() {}

  @Emit('inviteProjectMember')
  private inviteProjectMember(inviteDate: { email: string; message: string}) {
    return inviteDate;
  }
}
